require('../../modules/es6.math.tanh');
module.exports = require('../../modules/_core').Math.tanh;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/tanh.js
// module id = 1449
// module chunks = 0